<template>
    <b-row>
        <b-col class="mb-3" :lg="cols(val)" v-for="(val, propName) in metadata">
            <label class="text-truncate">{{ humanPropName(propName) }}</label>
            <div>{{ val }}</div>
        </b-col>
    </b-row>
</template>

<script>
  import startCase from "lodash/startCase";

  export default {
    props: ['metadata'],
    methods: {
      humanPropName(propName) {
        return startCase(propName).toUpperCase()
      },

      cols(val) {
        return val && val.length > 30 ? 6 : "";
      }
    }
  }
</script>